import { Camera, Eye, MapPin, Palette } from "lucide-react";

const mobileFeatures = [
  { icon: Camera, title: "AI scans service + mods", description: "Snap registrations, insurance cards, receipts, invoices, dyno sheets. AI extracts the details." },
  { icon: Eye, title: "Tag rides at meets", description: "Spotted posts straight to the public feed. Free for everyone." },
  { icon: MapPin, title: "Find local meets", description: "Discover, RSVP, and check in on the spot." },
  { icon: Palette, title: "Visual ride journal", description: "12 garage-themed photo filters. Crop, zoom, share." },
];

const APP_STORE_URL = "https://apps.apple.com/us/app/revhead-pro/id6760721252";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.garageregister.app&hl=en_US";

export function MobileAppSection() {
  return (
    <section className="bg-[#0C1222] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="font-heading text-3xl font-bold text-[#E8EDF2] sm:text-4xl">
            Now on iOS and Android
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-[#7A8FA3]">
            Your logbook, in your pocket. Track services, mods, and photos on the go.
          </p>
        </div>

        <div className="mt-10 flex items-center justify-center gap-4">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="h-[52px] w-[170px] overflow-hidden rounded-[10px] transition-opacity hover:opacity-80"
          >
            <img src="/badges/app-store.svg" alt="Download on the App Store" className="h-full w-full object-cover" />
          </a>

          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="h-[52px] w-[170px] overflow-hidden rounded-[10px] border border-[#a6a6a6] transition-opacity hover:opacity-80"
          >
            <img src="/badges/google-play.png" alt="Get it on Google Play" className="h-full w-full object-cover" />
          </a>
        </div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {mobileFeatures.map((feature) => {
            const Icon = feature.icon;
            return (
              <div
                key={feature.title}
                className="group relative rounded-xl border border-[#253448] bg-[#151D2E] p-6 transition-all duration-300 hover:-translate-y-1 hover:border-[#4DB8C7]/30 hover:bg-[#1E2B3D]"
              >
                <div className="mb-4 inline-flex rounded-lg bg-[#253448] p-2.5">
                  <Icon className="h-5 w-5 text-[#7A8FA3] transition-colors group-hover:text-[#4DB8C7]" />
                </div>
                <h3 className="font-heading text-base font-semibold text-[#E8EDF2]">
                  {feature.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-[#7A8FA3]">
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
